import * as ko from "knockout";
import {AbstractPicker, IPickerOptions} from "./AbstractPicker";
import {IObjectData, IRouteDefinition, IRuleset} from "../../index";
import {getAnyValue, getObjectDisplayName} from "../../util/misc";
import {global, lm} from "../../appContext";
import {ObjectTypeId} from "../../constants";
import {IKnockoutComponentDialogContent} from "../dialog/manager";
import {nsRuleset} from "../ruleset/nsRuleset";
import {getSearchObjectParams} from "../../util/request";
import PromiseRequest from "../../req/PromiseRequest";
import {PLEASE_WAIT_MESSAGE} from "../../constants/Language";
import {IDialogPickObjectParams} from "../object/dialog/pick";
import {nsTooltip} from "../../util/nsTooltip";
import userHtml from './user.html?raw';

export let template: string = userHtml;

export class viewModel extends AbstractPicker<IObjectData> {
    private readonly getTitle = nsTooltip.getTitle_objectdata
    private readonly PLEASE_WAIT_MESSAGE = PLEASE_WAIT_MESSAGE
    protected override readonly label = 'choose subject|s:((user|ac))'
    private readonly req_searchobject: PromiseRequest = global.getPromiseRequest('searchobject')
    private readonly isReady: KnockoutObservable<boolean | null> = ko.observable(null)

    constructor(options: IPickerOptions<IObjectData>) {
        super(options)
        this.initRequest()
    }

    protected initRequest(): Promise<any> {
        if (!this.options.value?.()) {
            this.isReady(true)
            return Promise.resolve()
        }
        let searchObjectParams = this.options.searchParams
        if (!searchObjectParams) {
            const ruleset: IRuleset = nsRuleset.generateRuleset({
                rules: [
                    nsRuleset.generateRule({
                        attribute: 'Id',
                        argumentoperator: 'Er lik',
                        argument: this.options.value(),
                    }),
                ]
            });
            searchObjectParams = getSearchObjectParams({
                jruleset: JSON.stringify(ruleset),
            });
        }
        return this.req_searchobject
            .request(searchObjectParams)
            .then((data: IObjectData[]) => {
                this.observable(data[0] ?? null)
                this.isReady(true);
            })
            .catch((reason: string) => {
                this.isReady(true);
            })
        ;
    }

    private getObjectDisplayName() {
        return this.observable()
            ? getObjectDisplayName(this.observable())
            : lm.t(getAnyValue<string>(this.label))
    }

    private onEditClick() {
        const params: IDialogPickObjectParams = {
            __routeDef: {labelLong: this.label, level: 1} as IRouteDefinition,
            objecttypeid: ObjectTypeId.User,
            onObjectSelected: (o: IObjectData) => this.observable(o),
            ...(this.options.additionalSyncfieldKeys ? {syncfieldNames: this.options.additionalSyncfieldKeys} : {}),
            __dialog: {width: 'auto'},
        };
        const component: IKnockoutComponentDialogContent = {
            name: 'component/object/dialog/pick',
            params: params
        };
        global.dialogManager.addCustom(component)
    }

}
